<template>
  <div>
    <div class="privilege-step">
      <step-navbar
        :step-active="stepActive"
        :tab-list="['Information', 'Criteria']"
      />
    </div>
    <div class="privilege-tab">
      <div class="row">
        <div class="col-12">
          <div class="p-reletion">
            <b-tabs v-model="stepActive" class="custom-tab">
              <b-tab
                :title="'Information'"
                :title-link-class="[
                  'font-medium-5',
                  { 'text-muted': stepActive !== 0 },
                  { bypass: modeEditor },
                ]"
                lazy
                active
              >
                <banner-create-edit-form
                  :bannerId="bannerId"
                  :is-edit="!modeEditor"
                  @onNextStep="stepActive++"
                />
              </b-tab>
              <b-tab
                :title="'Criteria'"
                :title-link-class="[
                  'font-medium-5',
                  { 'text-muted': stepActive !== 1 },
                  { bypass: modeEditor },
                ]"
                lazy
              >
                <banner-criteria
                  :bannerId="bannerId"
                  :is-edit="!modeEditor"
                  @onPreviousStep="stepActive--"
                />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerCreateEditForm from "./components/BannerCreateEditForm.vue";
import BannerCriteria from "./components/BannerCriteria.vue";
import useBannerInfo from "./hooks/useBannerInfo";
export default {
  components: { BannerCreateEditForm, BannerCriteria },
  setup() {
    const { stepActive, modeEditor, onNextStep, onPreviousStep, bannerId } =
      useBannerInfo();

    return {
      stepActive,
      modeEditor,
      onNextStep,
      onPreviousStep,
      bannerId,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/progress-nav.css";
</style>
